import React from 'react'
import useConfig from 'modules/config/state/use-config'
import PaymentSelectionButton from '../payment-selection-button'
import ACHActionButton from './ach-action-button'
import { PaymentSelectionButtonProps } from '../payment-selection-button'

/**
 * Conditional action button that chooses the appropriate button based on campaign type:
 * - Checkout campaigns (non-embedded): Uses ACHActionButton with validation
 * - Embedded campaigns: Uses PaymentSelectionButton (original behavior)
 */
const ConditionalACHActionButton = (props: PaymentSelectionButtonProps) => {
  const config = useConfig()
  const isCheckoutCampaign = !config.isEmbedded

  // For checkout campaigns, use the validating ACH action button
  if (isCheckoutCampaign) {
    return <ACHActionButton {...props} />
  }

  // For embedded campaigns, use the original payment selection button
  return <PaymentSelectionButton {...props} />
}

export default ConditionalACHActionButton
